import "./SuccessStories.module.css";
import MainNavigation from "@/reusable_sections/Header";
import RealResults from "./sections/RealResults";
import ClientVoices from "./sections/ClientVoices";
import StartYourStory from "./sections/StartYourStory";
import FooterEssentials from "@/reusable_sections/Footer";
export default function SuccessStoriesPage() {
  return <div>
      <MainNavigation />
      <RealResults />
      <ClientVoices />
      <StartYourStory />
      <FooterEssentials />
    </div>;
}